<template>
  <div class="app-box">
    <!-- 首页 -->
    <transition name="fade">
      <div class="index" v-if="showIndex">
        <div class="index-left ">
          <img src="../../src/assets/images/shouye/index-left.png" alt="" class="animate__animated animate__backInLeft">
        </div>

        <div class="index-right">
          <div class="index-title-top">
            <p class="animate__animated animate__fadeInTopRight index-font">
              {{ msg1 }}
            </p>
            <p class="animate__animated animate__fadeInTopRight index-font">
              {{ msg2 }}
            </p>
            <p class="animate__animated animate__backInRight index-font" id="border">
              {{ msg3 }}
            </p>
            <p class="animate__animated animate__backInRight index-font" id="eng">
              {{ msg4 }}
            </p>
            <p class="animate__animated animate__backInRight index-font" id="eng">
              {{ msg5 }}
            </p>
          </div>
          <div class="index-title-bottom">
            <p class="animate__animated animate__backInRight index-font">
              {{ msg6 }}
            </p>
            <p class="animate__animated animate__backInRight index-font">
              {{ msg7 }}
            </p>
          </div>
        </div>
      </div>
    </transition>

    <!-- Swiper -->
    <transition name="fade">
      <div class="swiper mySwiper" v-if="showSwiper" ref="swiper">
        <div class="swiper-wrapper swiper-no-swiping">

          <!-- 电子白皮书 -->
          <div class="swiper-slide baipi">
            <div class="lunbo-left bg1">
              <!-- <div class="sider-left-context inter">
              </div> -->
            </div>
            <div class="lunbo-right baipi_pdf">
              <div class="lunbo-right-center baipi-right">
                <img src="../assets/images/baipishu/bai.png" class="baipi-right-img" alt="" style="width:90%;height:auto;">
                <!-- <div class="readBaipi animate__animated animate__infinite animate__pulse" @click="goBook">
                  <div>点&nbsp;击</div>
                  <div>阅&nbsp;读</div>
                </div> -->
                <div class="watchBaiPi" @click="goBook">阅读白皮书</div>
              </div>
            </div>
          </div>

          <!-- zhuanjiafangtan -->
          <div class="swiper-slide">
            <div class="lunbo-left bg2">
              <div :class="`sider-left-context ${index == '2' ? 'inter' : ''}`">
              </div>
            </div>
            <div class="lunbo-right zhuanjia">
              <div class="lunbo-right-center">
                <div class="zhuanjia-item-top">
                  <div :class="`zhuanjia-item  ${index == '2' ? 'interContent' : ''}`">
                    <div class="zj_img">
                      <img src="../../src/assets/images/zhuanjiafangtan/王新川.jpg" alt="">
                      <div class="showZhuanJia" @click="goZhuanJiaVideo('wangxinchuan.mp4')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="`zhuanjia-item  ${index == '2' ? 'interContent1' : ''}`">
                    <div class="zj_img">
                      <img src="../../src/assets/images/zhuanjiafangtan/李新平.jpg" alt="">
                      <div class="showZhuanJia" @click="goZhuanJiaVideo('lixinping.mp4')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="`zhuanjia-item  ${index == '2' ? 'interContent' : ''}`">
                    <div class="zj_img">
                      <img src="../../src/assets/images/zhuanjiafangtan/刘文富.jpg" alt="">
                      <div class="showZhuanJia" @click="goZhuanJiaVideo('liuwenfu.mp4')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="`zhuanjia-item  ${index == '2' ? 'interContent1' : ''}`">
                    <div class="zj_img">
                      <img src="../../src/assets/images/zhuanjiafangtan/边存国.jpg" alt="">
                      <div class="showZhuanJia" @click="goZhuanJiaVideo('biancunguo.mp4')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="`zhuanjia-item  ${index == '2' ? 'interContent' : ''}`">
                    <div class="zj_img">
                      <img src="../../src/assets/images/zhuanjiafangtan/刘献社.jpg" alt="">
                      <div class="showZhuanJia" @click="goZhuanJiaVideo('liuxianshe.mp4')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- qiyefangtan -->
          <div class="swiper-slide">
            <div class="lunbo-left bg3">
              <div :class="`sider-left-context ${index == '3' ? 'inter' : ''}`">
              </div>
            </div>
            <div class="lunbo-right qiye">
                <div class="lunbo-right-center">
                  <div  :class="`qiye-box ${index == '3' ? 'interContent1' : ''}`">
                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-1.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('hegangshuzi.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                    
                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-7.png" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('kelindianqi.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>

                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-4.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('shuxueyanjiu.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="`qiye-box ${index == '3' ? 'interContent' : ''}`">
                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-8.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('xianhehuanbao.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                   
                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-3.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('',true,'qiyeImgList1')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>

                  <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-13.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('wulianwangyanjiu.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>

                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-11.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('',true,'qiyeImgList2')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="`qiye-box ${index == '3' ? 'interContent1' : ''}`">
                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-14.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('',true,'qiyeImgList3')">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-5.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('honglianjiuwu.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                    
                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-2.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('saikeputai.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>

                    <div class="qiye-item hvr-float-shadow">
                      <img class="qiye-logo" src="../assets/images/qiyefangtan/qiye-logo-9.jpg" alt="">
                      <div class="showQiYe" @click="goQiYeVideo('akaikeji.mp4',false)">
                        <div class="video-icon">
                          <img src="../assets/images/bo.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <!-- 高校访谈 -->
          <div class="swiper-slide college-scroll">
            <div class="lunbo-left college-left bg4">
              <div :class="`sider-left-context ${index == '4' ? 'inter' : ''}`">
              </div>
            </div>
            <college-scroll @getGaoXiaoImg="goGaoXiaoImg" @getGaoXiaoOpenData="goGaoXiaoVideo" @getGaoXiaoCloseData="closeGaoXiaoVideoDialog"/>
          </div>



          <!-- 小事记 -->
          <div class="swiper-slide">
            <div class="lunbo-left bg5">
              <div :class="`sider-left-context ${index == '5' ? 'inter' : ''}`">
              </div>
            </div>
            <div class="lunbo-right xiaoshi">
              <div class="lunbo-right-center">
                <iframe src="./pdf/xiaoShiJi.pdf" width="80%" height="80%"></iframe>
              </div>
            </div>
          </div>

          <!-- 调研过程 -->
          <div class="swiper-slide">
            <div class="lunbo-left bg6">
              <div :class="`sider-left-context ${index == '6' ? 'inter' : ''}`">
              </div>
            </div>
            <div class="lunbo-right diaoyan">
              
              <div class="lunbo-right-center">
                <Diaoyan ref="diaoyanBox"></Diaoyan>
              </div>
            </div>
          </div>

          <!-- 鸣谢名单 -->
          <div class="swiper-slide">
            <div class="lunbo-left bg7">
                <div class="sider-left-context inter">
                </div>
            </div>
            
            <div class="lunbo-right mingxie">
              <p>
                <span>注：排名不分先后，参照调研时间顺序排列</span>
              </p>
              <div class="mingxie-list">
                <!-- 鸣谢列表 -->
                <ul class="grid-content">
                  <li>河钢数字技术股份有限公司</li>
                  <li>石家庄晶澳光伏科技有限公司</li>
                  <li> 河北普兴电子科技股份有限公司</li>
                  <li>同辉电子科技股份有限公司</li>
                  <li>东旭集团有限公司</li>
                  <li>河北先河环保科技股份有限公司</li>
                  <li>石家庄国创明慧物联网科技有限公司</li>
                  <li>河北蓝蜂信息科技有限公司</li>
                  <li> 河北达梦软件技术有限公司</li>
                  <li>河北省登记结算有限公司</li>
                  <li>河北省惠信大数据科技服务有限公司</li>
                  <li>河北思维先旗电子工程有限公司</li>
                  <li>河北速联速通网络科技有限公司</li>
                  <li>软通动力技术服务有限公司石家庄分公司</li>
                  <li>石家庄辅良电子科技有限公司</li>
                  <li>石家庄伟纵电子科技有限公司</li>
                  <li>天津市南开太阳高技术发展有限公司</li>
                  <li>燕赵财产保险股份有限公司</li>
                  <li>易宝支付有限公司</li>
                  <li>中国移动河北分公司</li>
                  <li>河北省电子信息技术研究院</li>
                  <li>河北博士林科技开发有限公司</li>
                  <li>通联支付网络服务股份有限公司河北分公司</li>
  
                </ul>
                <ul class="grid-content">
                  <li>河北重优科技有限公司</li>
                  <li>河北柴火创客文化传播有限公司</li>
                  <li>河北好联点科技有限公司</li>
                  <li>河北燕大燕软信息系统有限公司</li>
                  <li>北京新方案科技有限公司</li>
                  <li>金蝶软件（中国）有限公司石家庄分公司</li>
                  <li>极近智能科技（河北）有限公司</li>
                  <li>河北志晟股份科技有限公司</li>
                  <li>石家庄阿凯科技有限公司</li>
                  <li>百搜网络科技</li>
                  <li>河北科创明达信息科技有限公司</li>
                  <li>博宇科技股份有限公司</li>
                  <li>福建国通信息科技有限公司</li>
                  <li>河北晨程新能源科技有限责任公司</li>
                  <li>河北科曼信息技术有限公司</li>
                  <li>河北电信设计咨询有限公司</li>
                  <li>中华通信系统有限责任公司河北分公司</li>
                  <li>河北辰聚通信技术有限公司</li>
                  <li>石家庄方哲电子科技有限公司</li>
                  <li>北京锦程前方科技有限公司河北分公司</li>
                  <li>河北东琳电子科技有限公司</li>
                  <li> 河北杰微科技有限公司</li>
                  <li>河北亿尔德科技集团有限公司</li>

                </ul>
                <ul class="grid-content">
                  <li>河北光之翼信息技术股份有限公司</li>
                  <li>杰勤张家口信息技术有限公司
                  </li>
                  <li>航迅信息技术有限公司
                  </li>
                  <li>张家口市宣化区沙塔软件有限公司
                  </li>
                  <li>张家口雷金电子商务有限公司
                  </li>
                  <li>张家口容绎软件技术有限公司
                  </li>
                  <li>张家口市泽美软件开发有限责任公司
                  </li>
                  <li>张家口钰辉起航科技有限公司
                  </li>
                  <li>河北九赋软件技术有限公司张家口分公司
                  </li>
                  <li>张家口如云电子商务有限公司
                  </li>
                  <li>张家口钱贝软件技术开发有限公司
                  </li>
                  <li>张家口钱贝软件技术开发有限公司
                  </li>
                  <li>众信嘉华张家口科技有限公司
                  </li>
                  <li>张家口优互软件技术开发有限公司
                  </li>
                  <li>张家口乐泽软件有限公司
                  </li>
                  <li>张家口零捌贰伍科技
                  </li>
                  <li>张家口优互软件技术开发有限公司
                  </li>
                  <li>蔚县云梅软件技术开发工作室
                  </li>
                  <li>张家口市宣化区博华教育科技有限公司
                  </li>
                  <li>张家口蜂鸟网络科技有限公司
                  </li>
                  <li>张家口垣通网络科技有限公司
                  </li>
                  <li>张家口思摩软件有限公司
                  </li>
                  <li>河北张宣高科科技有限公司
                  </li>
                </ul>
                <ul class="grid-content">
                  <li>饶杨科技河北有限公司
                  </li><li>北京钰辉讯捷信息技术有限公司
                  </li><li>河北巨灵仪表制造有限公司
                  </li><li>麦秒张家口教育科技有限公司
                  </li><li>张家口零捌贰伍科技
                  </li><li>河北江图科技有限公司
                  </li><li>苏州阿特斯新能源工程技术有限公司
                  </li><li>石家庄鑫灵信息技术有限责任公司
                  </li><li>阳光电源股份有限公司
                  </li><li>唐山市悦民新能源科技有限公司
                  </li><li>河北新露生物科技有限公司
                  </li><li>河北天测信息技术有限公司
                  </li><li>上海荣耶信息科技有限公司石家庄分公司
                  </li><li>河北唐讯信息技术股份有限公司
                  </li><li>河北京电新能源集团有限公司
                  </li><li>河北全民光伏科技有限公司
                  </li><li>河北省光伏新能源商会
                  </li><li>河北四两智能科技有限公司
                  </li><li>保定中泰新能源科技有限公司
                  </li><li>河北燚晶新能源科技有限公司
                  </li><li>晶阳（河北）电力工程设计有限公司
                  </li><li>河北澳玲新能源科技有限公司
                  </li><li>河北新盛美新能源有限公司
                  </li><li>石家庄睿聚信息科技有限公司
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev swiper-button-white"></div>
        <div class="swiper-button-next swiper-button-white"></div>
        <div class="swiper-pagination"></div>
      </div>
    </transition>


    <!-- pdf弹框 -->
    <el-dialog :visible.sync="pdfVisible" class="pdf-dialog" :show-close="false" close-on-press-escape>
      <div class="close-dialog" @click="closePdfDialog">
        X
      </div>
      <iframe src="./pdf/baiPiBook.pdf" width="100%" height="100%"></iframe>
    </el-dialog>

    <!-- 专家视频弹框开始 -->
    <el-dialog :visible.sync="zhuanJiaVideoVisible" :show-close="false" close-on-press-escape>
      <div class="close-dialog" @click="closeZhuanJiaVideoDialog">
        X
      </div>
      <div class="zhuanjia-videos">
        <video :src='`./video/zhuanjia/${zjVideo}`' controls autoplay width="100%" height="100%" ref="zhuanJiaVideoPlayer"></video>
        <!-- <video :src="require(`../../src/assets/video/${zjVideo}`)" controls autoplay width="100%" height="100%" ref="zhuanJiaVideoPlayer"></video> -->
        <!-- <video src='../../src/assets/video/zj1.mp4' controls autoplay width="100%" height="100%" ref="zhuanJiaVideoPlayer"></video> -->
      </div>
    </el-dialog>
    <!-- 专家视频弹框结束 -->

    <!-- 企业视频弹框开始 -->
    <el-dialog :visible.sync="qiYeVideoVisible" :show-close="false" close-on-press-escape>
      <div class="close-dialog" @click="closeQeYeVideoDialog">
        X
      </div>
      <div class="zhuanjia-videos">
        <video :src='`./video/qiye/${qyVideo}`' controls autoplay width="100%" height="100%" ref="qiYeVideoPlayer"></video>
      </div>
    </el-dialog>
    <!-- 企业视频弹框结束 -->

    <!-- 高校视频弹框开始 -->
    <el-dialog :visible.sync="gaoXiaoVideoVisible" :show-close="false" close-on-press-escape class="goxiao-dialog">
      <div class="close-dialog" @click="closeGaoXiaoVideoDialog">
        X
      </div>
      <div class="zhuanjia-videos">
        <video :src='`./video/gaoxiao/${gxVideo}`' controls autoplay width="100%" height="100%" ref="gaoXiaoVideoPlayer"></video>
      </div>
    </el-dialog>
    <!-- 高校视频弹框结束 -->

    <!-- 企业图片弹框开始 -->
    <el-dialog :visible.sync="qiyeImgShow"  id="qiye-img-dialog" close-on-press-escape :modal="false">
      <div class="close-dialog" @click="closeQiYeImg">
        X
      </div>
      <img :src="item.url" alt="" v-for="(item,index) in qiyeImgList" :key="index">
    </el-dialog>
    <!-- 企业图片弹框结束 -->

    <!-- 高校图片弹框开始 -->
    <el-dialog :visible.sync="gaoxiaoImgShow"  id="gaoxiao-img-dialog" close-on-press-escape :modal="false">
      <div class="close-dialog" @click="closeGaoXiaoImg">
        X
      </div>
      <img :src="item.url" alt="" v-for="(item,index) in gaoxiaoImgList" :key="index">
    </el-dialog>
    <!-- 高校图片弹框结束 -->

  </div>

</template>

<script>
import Swiper from "swiper";
import "../assets/css/animate.css";
import "../assets/css/index.css";
import "../assets/css/baipi.css";
import "../assets/css/lunbo.css";
import "../assets/css/common.css";
import "../assets/css/diaoyan.css";
import "swiper/css/swiper.min.css";
import CollegeScroll from "@/views/swiper-item/college-scroll.vue";
import Diaoyan from "@/views/swiper-item/diaoyan.vue";
export default {
  components: {CollegeScroll,Diaoyan},
  data() {
    return {
      msg1: "2023",
      msg2: "河北省电子信息产业",
      msg3: "人才白皮书",
      msg4: "Hebei Province Electronic Information Industry",
      msg5: "Talent Demand Research Report",
      msg6: "河北省工业和信息化厅",
      msg7: "河北省软件与服务外包职业教育集团",
      pdfVisible: false,
      showIndex: true,
      timer: null,
      index: 1,
      showSwiper: false,
      zhuanJiaVideoVisible: false,
      zjVideo: null,
      qiYeVideoVisible: false,
      qyVideo: null,
      gaoXiaoVideoVisible: false,
      gxVideo: null,
      //企业图片弹框
      qiyeImgShow: false,
      gaoxiaoImgShow: false,
      qiyeImgList:[],
      qiyeImgList1: [
        {url:require('../assets/images/qiye/jingaokeji.jpg')},
      ],
      qiyeImgList2: [
        {url:require('../assets/images/qiye/puxingdianzi.jpg')},
      ],
      qiyeImgList3: [
        {url:require('../assets/images/qiye/dianzixinxiyanjiu.jpg')},
      ],
      gaoxiaoImgList:[],
      lunboMain: null
    };
  },
  methods: {
    goBook() {
      this.pdfVisible = true;
    },
    goZhuanJiaVideo(videoUrl) {
      this.zjVideo = videoUrl;
      // console.log(this.zjVideo,9999);
      this.zhuanJiaVideoVisible = true;
    },
    goQiYeVideo(videoUrl,isImg=false,imgUrl) {
      // 判断是否是图片 
      if(isImg){
        const imgMap = {
          'qiyeImgList1': this.qiyeImgList1,
          'qiyeImgList2': this.qiyeImgList2,
          'qiyeImgList3': this.qiyeImgList3,
        };
        this.qiyeImgList = imgMap[imgUrl] || [];
        // console.log(this.qiyeImgList,9999);
        this.qiyeImgShow = true;
        return;
      }
      this.qyVideo = videoUrl;
      // console.log(this.qyVideo,9999);
      this.qiYeVideoVisible = true;
    },
    closeQiYeImg(){
      this.qiyeImgShow = false;
    },
    closeGaoXiaoImg(){
      this.gaoxiaoImgShow = false;
    },
    closePdfDialog() {
      this.pdfVisible = false;
    },
    closeZhuanJiaVideoDialog() {
      this.zhuanJiaVideoVisible = false;
      // 关闭弹框后 视频停止播放
      this.$refs.zhuanJiaVideoPlayer.pause();
    },
    closeQeYeVideoDialog() {
      this.qiYeVideoVisible = false;
      // 关闭弹框后 视频停止播放
      this.$refs.qiYeVideoPlayer.pause();
    },
    goGaoXiaoVideo(videoUrl,Status) {
      //接收子组件传过来的值
      this.gxVideo = videoUrl;
      this.gaoXiaoVideoVisible = Status;
    },
    closeGaoXiaoVideoDialog() {
      this.gaoXiaoVideoVisible = false;
      // 关闭弹框后 视频停止播放
      this.$refs.gaoXiaoVideoPlayer.pause();
    },
    //高校图片
    goGaoXiaoImg(ifImg,name){
      this.gaoxiaoImgShow = ifImg;
      if(name == '张家口职业技术学院') {
        this.gaoxiaoImgList = [
          {url:require('../assets/images/gaoxiao/zhangjiakouzhiye.jpg')}
        ]
      }
      if(name == '河北工程技术学院') {
        this.gaoxiaoImgList = [
          {url:require('../assets/images/gaoxiao/hebeigongcheng.jpg')}
        ]
      }
      if(name == '河北软件职业技术学院') {
        this.gaoxiaoImgList = [
          {url:require('../assets/images/gaoxiao/hebeiruanjianzhiye.jpg')}
        ]
      }
      if(name == '燕山大学') {
        this.gaoxiaoImgList = [
          {url:require('../assets/images/gaoxiao/yanshandaxue.jpg')}
        ]
      }
    }
  },
  mounted() {
    // 轮播主体
    const _this = this;
    this.timer = setTimeout(() => {
      this.showIndex = false; // 3秒后，index隐藏
      this.showSwiper = true; // 3秒后，swiper显示
      this.$nextTick(() => {
        _this.lunboMain = new Swiper(".mySwiper", {
          loop: true,
          // grabCursor : true,
          // mousewheel: true,
          // initialSlide: 2,
          speed: 1000,
          on: {
            slideChangeTransitionEnd: function () {
              _this.$nextTick(()=>{
                _this.index = String(this.activeIndex % 8);
                // console.log(_this.index,9999);
              })
            },
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              console.log(index,className,88888);
              switch(index){
                case 0:
                  return '<span class="' + className + '"><br/>电子白皮书</span>';
                  break;
                case 1:
                  return '<span class="' + className + '"><br/>专家访谈</span>';
                  break;
                case 2:
                  return '<span class="' + className + '"><br/>企业访谈</span>';
                  break;
                case 3:
                  return '<span class="' + className + '"><br/>高校访谈</span>';
                  break;
                case 4:
                  return '<span class="' + className + '"><br/>小事记</span>';
                  break;
                case 5:
                  return '<span class="' + className + '"><br/>调研过程</span>';
                  break;
                case 6:
                  return '<span class="' + className + '"><br/>鸣谢单位</span>';
                  break;
              }
              
            },
        },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    }, 1800);
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer); // 清除定时器
    }
  },
};
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

// app-box样式
.app-box {
  width: 100%;
  height: 100%;
}

// 弹框样式
/deep/ .el-dialog {
  width: 95% !important;
  height: 90vh;
  margin-top: 4vh !important;
}

/deep/ .el-dialog__header {
  display: none;
}

.zhuanjia-videos {
  width: 100%;
  height: 100%;
}

//关闭弹框按钮
.close-dialog {
  width: 40px;
  height: 40px;
  background: rgba(198, 198, 198);
  // border-end-start-radius: 60px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  color: #FFF;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.close-dialog:hover {
  cursor: pointer;
  background: rgb(145, 140, 140, .5);
  transition: all .3s;
}


// 鸣谢格柵
.grid-content {
  height: 100%;
  font-size: 15px;
  text-align: left;
  min-width: 300px;
  box-sizing: border-box;
  margin: 0px 10px 0px 10px;
}
.mingxie {
  width:86%;
  margin:0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-image: url(../assets/images/bg_mx.jpg);
  p {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    text-align: left;
    margin: 0px;
    font-weight: normal;
    padding-left:50px;
  }
  .mingxie-list {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .grid-content li {
    padding: 7.5px;
    color: #fff;
    transition: all .7s;
  }
}
.grid-content li:hover {
  cursor: pointer;
  color: rgb(83, 189, 224);
}

//小事记
.xiaoshi {
  background: url('../assets/images/bg_yh.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

//企业图片弹框
/deep/ #qiye-img-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //  height: 100% !important;
  width: 70% !important;
  margin: 0 auto;
  height: auto !important;
  padding: 0px;
  // background: pink;
}

/deep/ #qiye-img-dialog::-webkit-scrollbar {
  display: none;
}

/deep/ #qiye-img-dialog  .el-dialog__body {
  width: 100%;
  height: auto !important;
  background: rgb(224,234,238);
  display: flex;
  justify-content: center;
  // flex-wrap: wrap;
  flex-direction: column;
}

//高校图片弹框
/deep/ #gaoxiao-img-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //  height: 100% !important;
  width: 70% !important;
  margin: 0 auto;
  height: auto !important;
  padding: 0px;
  // background: pink;
}

/deep/ #gaoxiao-img-dialog::-webkit-scrollbar {
  display: none;
}

/deep/ #gaoxiao-img-dialog  .el-dialog__body {
  width: 100%;
  height: auto !important;
  background: rgb(224,234,238);
  display: flex;
  justify-content: center;
  // flex-wrap: wrap;
  flex-direction: column;
}

/deep/.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: .3s opacity;
  transform: translate3d(0,0,0);
  z-index: 10;
  left: 50%;
  bottom: 10px;
  // 向左偏移自身的百分之50
  margin-left: -25%;
}

/deep/.swiper-pagination-bullet {
    width: 150px;
    height: 50px;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
    color: #fff;
    opacity: 1;
    background-color: rgba(193, 184, 228, 0);
    background-image: url(../assets/images/lm_bg.png) !important;
    /* border-bottom:1px solid #000; */
    margin: 0 !important;
    border-radius:0%;
  }

  /deep/.swiper-pagination-bullet-active {
    color: rgba(255, 255, 255, 0.864);
    font-size: 16px;
    background-image: url(../assets/images/lm_xzbg.png) !important;
  }
</style>
